<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="h-screen flex overflow-hidden bg-white">
    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog
        as="div"
        static
        class="fixed inset-0 flex z-40 md:hidden"
        @close="sidebarOpen = false"
        :open="sidebarOpen"
      >
        <TransitionChild
          as="template"
          enter="transition-opacity ease-linear duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-600 bg-opacity-75" />
        </TransitionChild>
        <TransitionChild
          as="template"
          enter="transition ease-in-out duration-300 transform"
          enter-from="-translate-x-full"
          enter-to="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leave-from="translate-x-0"
          leave-to="-translate-x-full"
        >
          <div class="relative flex-1 flex flex-col max-w-xs w-full bg-white">
            <TransitionChild
              as="template"
              enter="ease-in-out duration-300"
              enter-from="opacity-0"
              enter-to="opacity-100"
              leave="ease-in-out duration-300"
              leave-from="opacity-100"
              leave-to="opacity-0"
            >
              <div class="absolute top-0 right-0 -mr-12 pt-2">
                <button
                  class="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  @click="sidebarOpen = false"
                >
                  <span class="sr-only">Close sidebar</span>
                  <XIcon class="h-6 w-6 text-white" aria-hidden="true" />
                </button>
              </div>
            </TransitionChild>
            <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
              <!-- <div class="flex-shrink-0 flex items-center px-4">
                <img class="h-8 w-auto"
                  src="https://tailwindui.com/img/logos/workflow-logo-blue-600-mark-gray-800-text.svg" alt="Workflow" />
              </div> -->
              <nav class="mt-5 px-2 space-y-1">
                <Listbox as="div" class="w-full" v-model="selected">
                  <div class="mt-1 relative">
                    <ListboxButton
                      class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                      <span class="flex items-center">
                        <!-- <img :src="selected.imageUrl ? selected.imageUrl : null" alt="" class="flex-shrink-0 h-6 w-6 rounded-full" /> -->
                        <span class="ml-3 block truncate">{{
                          selected?.name
                        }}</span>
                      </span>
                      <span
                        class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                      >
                        <SelectorIcon
                          class="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </span>
                    </ListboxButton>

                    <transition
                      leave-active-class="transition ease-in duration-100"
                      leave-from-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <ListboxOptions
                        class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                      >
                        <ListboxOption
                          as="template"
                          v-for="operator in operators"
                          :key="operator.operatorId"
                          :value="operator"
                          v-slot="{ selected }"
                        >
                          <li
                            @click="selectOperator(operator)"
                            :class="[
                              operator.operatorId ==
                              store.state.selectedOperator.operatorId
                                ? 'text-white bg-indigo-600'
                                : 'text-gray-900',
                              'cursor-default select-none relative py-2 pl-3 pr-9',
                            ]"
                          >
                            <div class="flex items-center">
                              <!-- <img :src="operator.imageUrl ? selected.imageUrl : null" alt="" class="flex-shrink-0 h-6 w-6 rounded-full" /> -->
                              <span
                                :class="[
                                  selected ? 'font-semibold' : 'font-normal',
                                  'ml-3 block truncate',
                                ]"
                              >
                                {{ operator.name }}
                              </span>
                            </div>

                            <span
                              v-if="selected"
                              :class="[
                                operator.operatorId ==
                                store.state.selectedOperator.operatorId
                                  ? 'text-white'
                                  : 'text-indigo-600',
                                'absolute inset-y-0 right-0 flex items-center pr-4',
                              ]"
                            >
                              <CheckIcon class="h-5 w-5" aria-hidden="true" />
                            </span>
                          </li>
                        </ListboxOption>
                      </ListboxOptions>
                    </transition>
                  </div>
                </Listbox>
                <div v-for="item in navigation" :key="item.name">
                  <p
                    v-if="item.separator"
                    class="text-gray-400 group-hover:text-gray-500 ml-4 h-6 flex-shrink-0"
                  >
                    {{ $t(`messages.navigation.${camalize(item.name)}`) }}
                  </p>
                  <a
                    v-else
                    :href="`/${item.href}`"
                    :class="[
                      item.current
                        ? 'bg-gray-100 text-gray-900'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                      'group flex items-center px-2 py-2 text-base font-medium rounded-md',
                    ]"
                  >
                    <component
                      :is="item.icon"
                      :class="[
                        item.current
                          ? 'text-gray-500'
                          : 'text-gray-400 group-hover:text-gray-500',
                        'mr-4 flex-shrink-0 h-6 w-6',
                      ]"
                      aria-hidden="true"
                    />
                    {{ $t(`messages.navigation.${camalize(item.name)}`) }}
                  </a>
                </div>
              </nav>
            </div>
            <div class="flex-shrink-0 flex border-t border-gray-200 p-4">
              <a href="#" class="flex-shrink-0 group block">
                <div class="flex items-center gap-2">
                  <div>
                    <img
                      class="inline-block h-10 w-10 rounded-full"
                      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt=""
                    />
                  </div>
                  <div class="ml-3">
                    <p
                      class="text-base font-medium text-gray-700 group-hover:text-gray-900"
                    >
                      {{ store.state.user.username }}
                    </p>
                    <p
                      class="text-sm font-medium text-gray-500 group-hover:text-gray-700"
                    >
                      {{ store.state.user.ip }}

                      <button
                        @click="logout"
                        class="inline-block h-9 w-9 bg-gray-100 rounded-full"
                      >
                        <font-awesome-icon
                          class="text-gray-500"
                          :icon="['fas', 'sign-out']"
                        />
                      </button>
                    </p>
                  </div>
                  <div
                    @click="onChangeLanguage()"
                  >
                    <img
                      class="rounded-full w-8 h-8 cursor-pointer"
                      :src="
                        $i18n.locale == 'en'
                          ? 'https://upload.wikimedia.org/wikipedia/en/thumb/a/ae/Flag_of_the_United_Kingdom.svg/1600px-Flag_of_the_United_Kingdom.svg.png'
                          : 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/255px-Flag_of_Thailand.svg.png'
                      "
                      alt=""
                    />
                  </div>
                </div>
              </a>
            </div>
          </div>
        </TransitionChild>
        <div class="flex-shrink-0 w-14">
          <!-- Force sidebar to shrink to fit close icon -->
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div class="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white">
          <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <div class="flex items-center flex-shrink-0 px-4 pb-1">
              <Listbox as="div" class="w-full" v-model="selected">
                <div class="mt-1 relative">
                  <ListboxButton
                    class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    <span class="flex items-center">
                      <!-- <img :src="selected.imageUrl ? selected.imageUrl : null" alt="" class="flex-shrink-0 h-6 w-6 rounded-full" /> -->
                      <span class="ml-3 block truncate">{{
                        selected?.name
                      }}</span>
                    </span>
                    <span
                      class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
                    >
                      <SelectorIcon
                        class="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </span>
                  </ListboxButton>

                  <transition
                    leave-active-class="transition ease-in duration-100"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0"
                  >
                    <ListboxOptions
                      class="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                    >
                      <ListboxOption
                        as="template"
                        v-for="operator in operators"
                        :key="operator.operatorId"
                        :value="operator"
                        v-slot="{ selected }"
                      >
                        <li
                          @click="selectOperator(operator)"
                          :class="[
                            operator.operatorId ==
                            store.state.selectedOperator.operatorId
                              ? 'text-white bg-indigo-600'
                              : 'text-gray-900',
                            'cursor-default select-none relative py-2 pl-3 pr-9',
                          ]"
                        >
                          <div class="flex items-center">
                            <!-- <img :src="operator.imageUrl ? selected.imageUrl : null" alt="" class="flex-shrink-0 h-6 w-6 rounded-full" /> -->
                            <span
                              :class="[
                                selected ? 'font-semibold' : 'font-normal',
                                'ml-3 block truncate',
                              ]"
                            >
                              {{ operator.name }}
                            </span>
                          </div>

                          <span
                            v-if="selected"
                            :class="[
                              operator.operatorId ==
                              store.state.selectedOperator.operatorId
                                ? 'text-white'
                                : 'text-indigo-600',
                              'absolute inset-y-0 right-0 flex items-center pr-4',
                            ]"
                          >
                            <CheckIcon class="h-5 w-5" aria-hidden="true" />
                          </span>
                        </li>
                      </ListboxOption>
                    </ListboxOptions>
                  </transition>
                </div>
              </Listbox>
            </div>
            <!--  desktop size -->
            <nav class="mt-5 flex-1 px-2 bg-white space-y-1">
              <router-link
                v-slot="{ isActive }"
                :to="`/${item.href}`"
                v-for="item in navigation"
                :key="item.name"
                :class="[
                  item.separator ? 'pointer-events-none' : '',
                  'cursor-pointer',
                ]"
              >
                <span
                  :class="[
                    isActive
                      ? 'bg-gray-100 text-gray-900'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
                    `group flex items-center px-2 py-2 text-sm font-medium rounded-md`,
                    item.separator
                      ? 'pt-6 uppercase font-bold pb-2 text-gray-900'
                      : '',
                  ]"
                >
                  <span
                    :class="[
                      item.separator ? '' : 'w-8 text-center',
                      'inline-block',
                    ]"
                  >
                    <font-awesome-icon
                      v-if="!item.separator"
                      :class="[
                        item.current
                          ? 'text-gray-500'
                          : 'text-gray-400 group-hover:text-gray-500',
                        'mr-3 flex-shrink-0 h-6 w-6',
                      ]"
                      :icon="['far', item.icon]"
                      transform="down-1"
                    />
                  </span>
                  <span :class="item.separator ? 'text-xs' : ''">
                    {{ $t(`messages.navigation.${camalize(item.name)}`) }}

                    <!-- {{ item.name }} -->
                  </span>
                  <span style="color: red">
                    {{
                      item.name.includes("Approve Topup")
                        ? `&nbsp;(${cm_topup} | ${rtb_topup})`
                        // ? "&nbsp;(" + (cm_topup + rtb_topup) + ")"
                        : ""
                    }}
                    {{
                      item.name.includes("Approve Payout")
                        ? `&nbsp;(${cm_payout} | ${rtb_payout})`
                        // ? "&nbsp;(" + (cm_payout + rtb_payout) + ")"
                        : ""
                    }}
                  </span>
                  <span
                    v-if="
                      item.name ===
                        `${$t('messages.navigation.rewardRedemption')}` &&
                      isWaitforApprove
                    "
                  >
                    <div class="w-3 h-3 bg-red-500 rounded-full ml-1"></div>
                  </span>
                  <span
                    v-if="
                      item.name ===
                        `${$t('messages.navigation.affiliatePayout')}` &&
                      isDownlinePending
                    "
                  >
                    <div class="w-3 h-3 bg-red-500 rounded-full ml-1"></div>
                  </span>
                </span>
              </router-link>
            </nav>
            <!-- end of nav bar -->
          </div>
          <div class="border-t border-gray-200 p-4">
            <div class="flex justify-around">
              <div class="ml-3 float-left">
                <p
                  class="text-sm font-medium text-gray-700 group-hover:text-gray-900"
                >
                  {{ store.state.user.username }}
                </p>
                <p
                  class="text-xs font-medium text-gray-500 group-hover:text-gray-700"
                >
                  {{ store.state.user.ip }}
                </p>
              </div>
              <div @click="onChangeLanguage()">
                <img
                  class="rounded-full w-8 h-8 cursor-pointer"
                  :src="
                    $i18n.locale === 'en'
                        ? 'https://upload.wikimedia.org/wikipedia/en/thumb/a/ae/Flag_of_the_United_Kingdom.svg/1600px-Flag_of_the_United_Kingdom.svg.png'
                        : 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/255px-Flag_of_Thailand.svg.png'
                  "
                  alt=""
                />
              </div>

              <button
                @click="logout"
                class="inline-block h-9 w-9 bg-gray-100 rounded-full"
              >
                <font-awesome-icon
                  class="text-gray-500"
                  :icon="['fas', 'sign-out']"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <div class="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
        <button
          class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
          @click="sidebarOpen = true"
        >
          <span class="sr-only">Open sidebar</span>
          <MenuIcon class="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <main
        class="flex-1 relative z-0 overflow-y-auto focus:outline-none bg-gray-100"
      >
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, onUnmounted } from "vue";
import { inject } from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Pusher from "pusher-js";

import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";
import {
  MenuIcon,
  XIcon,
  CheckIcon,
  SelectorIcon,
} from "@heroicons/vue/outline";
import { camalize } from "@/utils/tools";
import { useI18n } from "vue-i18n";

let navigation = [];

export default {
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    MenuIcon,
    XIcon,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
  },
  setup() {
    const axios = inject("$axios");
    const t = inject("$t");
    const sidebarOpen = ref(false);
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const rootPath = router.options.routes.find((r) => r.meta.is_root);
    const operators = ref([]);
    const selected = ref(null);
    const topupNoti = ref(null);
    const withdrawNoti = ref(null);
    const isWaitforApprove = ref(false);
    const isDownlinePending = ref(false);
    const {locale} = useI18n({useScope: 'global'})

    const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
      cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    });
    const channel = pusher.subscribe("noti_pending_trx");

    navigation = [];

    operators.value = store.state.user.operators.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    /** init selected operator */
    const userOperators = store.state.user.operators
    if (!store.state.selectedOperator) {
      selected.value = userOperators[0];
    } else {
      const asOperator =  userOperators.find((val) => val.operatorId === store.state.selectedOperator.operatorId)
      selected.value = asOperator
    }
    axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-config/${selected.value.operatorId}`).then(({ data:getOperatorPaymentConfig }) => {
      const paymentVersion =(!getOperatorPaymentConfig)? 'v1':(getOperatorPaymentConfig.version)? `v${getOperatorPaymentConfig.version}`: 'v1'
      store.commit("updateSelectedOperator", {...selected.value, paymentVersion, bypassPaymentApprovalTotp: !getOperatorPaymentConfig.bypassPaymentApprovalTotp, multipleDeposit: getOperatorPaymentConfig.multipleDeposit});
    }).catch(() => {
      store.commit("updateSelectedOperator", {...selected.value, paymentVersion: 'v1'});
    })


    axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/payment/pagination`, {page: 1, pageSize: 100})
        .then((getPaymentResponse) => {
          const financeModuleCode = getPaymentResponse.data.result.map((payment) => payment.name)
          store.commit("setFinanceModuleCode", financeModuleCode);
        })



    rootPath.children.forEach((route) => {
      if(route.meta.is_hidden === true) return
      if (route.meta.permission) {
        if (store.state.user.permissions.includes(route.meta.permission)) {
          navigation.push({
            name: route.name,
            href: route.path,
            icon: route.meta.icon,
            separator: route.meta.separator || false,
          });
        }
      } else {
        navigation.push({
          name: route.name,
          href: route.path,
          icon: route.meta.icon,
        });
      }
      /** in case have no MANUAL permission */
    //   if (
    //     store.state.selectedOperator && !store.state.selectedOperator.paymentAccountTypes.includes("MANUAL")
    //   ) {
    //     navigation = navigation.filter(
    //       (nav) =>
    //         nav.name.toLowerCase() !== "manual deposit" &&
    //         nav.name.toLowerCase() !== "manual withdraw"
    //     );
    //   }
    });

    const rtb_topup = ref(0);
    const rtb_payout = ref(0);
    const cm_topup = ref(0);
    const cm_payout = ref(0);

    const onChangeLanguage = () => {
      const newLang = store.state.language === 'en' ? 'th' : 'en'
      locale.value = newLang
      store.commit("setAppLanguage", {
        language: newLang,
      });
    }

    const pusherSubscriber = (operatorId) => {
      // console.log(channel);
      channel.bind(`pending_trx`, async (data) => {
        // console.log(data);
        const operatorCmData = data.cm.filter(
          (e) => e.operator_id == store.state.selectedOperator.operatorId
        );
        const operatorRtbData = data.rtb.filter(
          (e) => e.operator_id == store.state.selectedOperator.operatorId
        );
        rtb_topup.value = operatorRtbData[0] ? operatorRtbData[0].topup : 0;
        rtb_payout.value = operatorRtbData[0] ? operatorRtbData[0].payout : 0;
        cm_topup.value = operatorCmData[0]
          ? operatorCmData[0].topup
          : 0;
        cm_payout.value = operatorCmData[0]
          ? operatorCmData[0].payout
          : 0;

        let notificationCount = 0;

        if (store.state.user.payoutNotification) {
          notificationCount += rtb_payout.value + cm_payout.value;
        }

        if (store.state.user.topupNotification) {
          notificationCount += rtb_topup.value + cm_topup.value;
        }

        if (
          notificationCount > 0 &&
          store.state.user.token &&
          store.state.user.permissions.includes("OPERATOR.READ.FINANCE_APPROVE")
        ) {
          const notificationSound = {
            soundurl:
              process.env.VUE_APP_NOTIFICAITON_SOUND ||
              "https://cdn.betbkk.com/notification-tone-swift-gesture.mp3",
          };
          var audio = new Audio(notificationSound.soundurl);
          audio.play();
        }
      });
    };

    const selectOperator = (operator) => {
      if (store.state.selectedOperator.operatorId !== operator.operatorId) {
        store.commit("updateSelectedOperator", operator);
        window.location.reload();
      }
    };

    const getShipmentNotification = async () => {
      const { data } = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/shipment/notification`);
      isWaitforApprove.value = data.isPending;
    };

    const getDownlinePendingNotification = async () => {
      const payload = { operator_id: store.state.selectedOperator.operatorId };
      const { data } = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/shipment/notification`, payload);
      isDownlinePending.value = data.isPending;
    };

    const logout = () => {
      store.commit("removeUserInfo");
      store.commit("removeOperators");
      router.push({ name: "Login" });
    };

    if (!route.path || route.path == "/") {
      // console.log("redirect to " + `/${navigation[0].href}`)
      router.push({ path: `/${navigation[0].href}` });
    }

    const intervalGetNotification = async () => {
      Promise.all([
        await getShipmentNotification(),
        await getDownlinePendingNotification(),
      ]);
    };

    onMounted(async () => {
      if (
        store.state.user.token &&
        store.state.user.permissions.includes("OPERATOR.READ.FINANCE_APPROVE")
      ) {
        pusherSubscriber(store.state.selectedOperator.operatorId);
      }
      await getShipmentNotification();
      await getDownlinePendingNotification();
      setInterval(async () => intervalGetNotification(), 30000);
      // dointerval();
    });

    onUnmounted(() => {
      clearInterval(intervalGetNotification());
    });

    return {
      route,
      store,
      navigation,
      sidebarOpen,
      operators,
      selected,
      selectOperator,
      logout,
      topupNoti,
      withdrawNoti,
      rtb_topup,
      rtb_payout,
      cm_topup,
      cm_payout,
      camalize,
      isWaitforApprove,
      isDownlinePending,
      onChangeLanguage,
    };
  },
};
</script>
